import type { HandleClientError } from '@sveltejs/kit/hooks';
import { clientErrorReport } from '#lib/clientErrors/clientErrorReport.js';
import { reportClientError } from '#lib/clientErrors/clientErrors.remote.js';

// Errors thrown with error(...) and SvelteKit's own (a 404 on navigation) are
// expected; an unknown error is a crash in our code, and only the browser saw it.
export const handleError: HandleClientError = ({ kind, error, event }) => {
	if (kind !== 'unknown') return;
	void reportClientError(clientErrorReport(error, event.url, event.route.id));
};
